import { render, staticRenderFns } from "./DepRehabiltation.vue?vue&type=template&id=48013afc&scoped=true&"
import script from "./DepRehabiltation.vue?vue&type=script&lang=js&"
export * from "./DepRehabiltation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48013afc",
  null
  
)

export default component.exports